import { ExchangeHelper } from "app/helpers/exchangeHelper";
import {
  EventRunnerType,
  EventType,
  RunnerAggregatedPriceType,
} from "app/types/eventType";
import isEmpty from "lodash/isEmpty";
import DisplayExchangeMarketRunnerPriceChange from "../DisplayExchangeMarketRunnerPriceChange/DisplayExchangeMarketRunnerPriceChange";
import "./ExchangeMarketRunnerPriceWrapper.scss";

function ExchangeMarketRunnerPriceWrapper(props: {
  prices: RunnerAggregatedPriceType[];
  event: EventType;
  runner: EventRunnerType;
}) {
  const { event, runner } = props;
  let blankCells = ExchangeHelper.compileExchangePrices(props.prices);

  if (isEmpty(blankCells)) return <>blank</>;

  return (
    <span className={"exchange__runner-prices-wrapper"}>
      {blankCells &&
        blankCells.map((price: RunnerAggregatedPriceType, index: number) => (
          <DisplayExchangeMarketRunnerPriceChange
            price={price}
            index={index}
            event={event}
            runner={runner}
            key={runner.id + index}
          ></DisplayExchangeMarketRunnerPriceChange>
        ))}
    </span>
  );
}

export default ExchangeMarketRunnerPriceWrapper;
